import type { SVGProps } from 'react';
const SvgTitle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#title_svg__a)">
      <path fill="currentColor" d="M5 4v3h5.5v12h3V7H19V4H5Z" />
    </g>
    <defs>
      <clipPath id="title_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTitle;
